import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import BrandList from './components/Brand/BrandList';
import SliderList from './components/Slider/SliderList';
import CategoriesList from './components/Categories/CategoriesList';
import BrandFormList from './components/BrandForm/BrandFormList'
import GalleryList from './components/ImageUploader/GalleryList';
import { Typography } from '@mui/material';
import ViewCategoryDealList from './components/ViewCategoryDeal/ViewCategoryDealList';
import Contact from './components/Contact/Contact';
import DashboardDisplay from './components/Dashboard/Dashboard';
import ProductList from './components/Products/ProductList';



const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f5f7fa',
    },
  },
});

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const ProtectedRoute = ({ children }) => {
    return localStorage.getItem('authToken') ? children : <Navigate to="/dashboard" />;
  };

  const token = localStorage?.getItem("authToken");


  const sidebarWidth = isSidebarOpen ? 290 : 82;

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <Box
          sx={{
            flexGrow: 1,
            marginLeft: `${sidebarWidth}px`,
            width: `calc(100% - ${sidebarWidth}px)`,
            transition: 'margin-left 0.3s, width 0.3s',
            bgcolor: 'background.default',
          }}
        >
          <Topbar sidebarOpen={isSidebarOpen} />
          <Box
            component="main"
            sx={{
              p: 3,
              mt: 8,
            }}
          >
            <Routes>
              <Route
                index
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardDisplay />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/getproduct"
                element={
                  <ProtectedRoute>
                    <ProductList />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="/analytics"
                element={
                  <ProtectedRoute>
                    <AnalyticsPage />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/getslider"
                element={
                  <ProtectedRoute>
                    <SliderList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/viewcategorydeal"
                element={
                  <ProtectedRoute>
                    <ViewCategoryDealList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/getcategories"
                element={
                  <ProtectedRoute>
                    <CategoriesList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/brandforms"
                element={
                  <ProtectedRoute>
                    <BrandFormList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gallery"
                element={
                  <ProtectedRoute>
                    <GalleryList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/brand"
                element={
                  <ProtectedRoute>
                    <BrandList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contact"
                element={
                  <ProtectedRoute>
                    <Contact />
                  </ProtectedRoute>
                }
              />
              {/* <Route path="/" element={<DashboardDisplay />} /> */}
              <Route path="/users" element={<Users />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

function Users() {
  return (
    <Box>
      <Typography variant="h4">Users</Typography>
    </Box>
  );
}

function NotFound() {
  return (
    <Box>
      <Typography variant="h4">404 - Not Found</Typography>
    </Box>
  );
}

export default App;